import React from 'react';

interface StatBoxProps {
  label: string;
  value: number | string;
  color?: string;
}

export const StatBox: React.FC<StatBoxProps> = ({ label, value, color = "text-dark-text" }) => (
  <div className="flex flex-col mb-4 p-3 rounded-xl bg-gradient-to-br from-dark-surface/60 to-dark-bg/30 border border-dark-border/20">
    <span className="text-[10px] text-dark-muted uppercase tracking-widest mb-1.5 font-medium">{label}</span>
    <span className={`text-2xl font-bold tracking-tight ${color}`}>{value}</span>
  </div>
);
